class cAdminCategories {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elBtnAdd = $('#addcategory');
        var elCategoryTable = $('#category-table');
        var elAddCategorySubmitBtn = $('#add-category-btn');
        var elEditCategorySubmitBtn = $('#edit-category-btn');
        var elSetTopLevelCheckbox = $('#set-top-level');
        this.elCategoryAddForm = $('#category-add-form');
        this.elCategoryEditForm = $('#category-edit-form');
        this.elEditId = $('#edit-id');
        this.elEditName = $('#edit-name');
        this.elEditDocument = $('#edit-book');
        this.elEditCategoryDocumentList = $('#edit-category-booklist');
        elBtnAdd.click(function () { self.onAddCategoryClick(); });
        this.elEditDocument.change(function () { self.onEditDocumentChange(); });
        elCategoryTable.click(function (e) { self.categoryTableClickHandler(e); });
        elAddCategorySubmitBtn.click(function (e) { self.submitAddCategory(this, e); });
        elEditCategorySubmitBtn.click(function (e) { self.submitEditCategory(this, e); });
        elSetTopLevelCheckbox.on('change', function (e) { self.hideCategoryTree(e); });
        $(elCategoryTable).dataTable({
            'paging': true,
            'pageLength': 100,
            'ordering': true,
            'info': true,
            'order': [[1, 'asc']],
            'columnDefs': [
                { "orderable": false, "targets": [0, 2, 3] }
            ],
            //Text translation options
            //Note the required keywords between underscores (e.g _MENU_)
            oLanguage: {
                sSearch: 'Search all columns:',
                sLengthMenu: '_MENU_ Categories per page',
                info: 'Showing page _PAGE_ of _PAGES_',
                zeroRecords: 'Nothing found - sorry',
                infoEmpty: 'No records available',
                infoFiltered: '(filtered from _MAX_ total records)'
            }
        });
    }
    //User adding new document category
    submitAddCategory(btn, e) {
        if (!$(this.elCategoryAddForm).find('*[name="name"]').val()) {
            return notify.error("Please specify a name for the category");
        }
        $(btn).button('loading');
        $(this.elCategoryAddForm).ajaxSubmit({
            url: URL_ADMIN + '/categories/add/',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                    $(btn).button('reset');
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return;
    }
    //User submitting the edit of an existing document category
    submitEditCategory(btn, e) {
        if (!$(this.elCategoryEditForm).find('*[name="name"]').val()) {
            return notify.error("Please specify a name for the category");
        }
        $(btn).button('loading');
        $(this.elCategoryEditForm).ajaxSubmit({
            url: URL_ADMIN + '/categories/update/',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                    $(btn).button('reset');
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return false;
    }

    hideCategoryTree(e) {
        $('#edit-category-parent-category-tree').toggle();
    }

    categoryTableClickHandler(e) {
        var target = e.target;
        var row = $(target).closest('tr').get(0);
        if ($(target).hasClass('edit')) {
            this.onCategoryEditClick(row);
        }
        else if ($(target).hasClass('del')) {
            this.onCategoryDelClick(row);
        }
    }
    onEditDocumentChange() {
        var self = this;
        var categoryId = this.elEditId[0].value;
        var bookId = this.elEditDocument[0].options[this.elEditDocument[0].selectedIndex].value;
        this.addCategoryDocument(categoryId, bookId, function (categoryDocument) { self.addCategoryDocumentItem(categoryDocument); });
        this.elEditDocument[0].selectedIndex = 0;
    }
    /*User clicks to edit an existing category*/
    onCategoryEditClick(row) {
        $('#edit-category-modal').modal('show');
        $('#edit-category-modal').find('#edit-id').val($(row).data('id'));
        $('#edit-category-modal').find('#edit-name').val($(row).data('name'));
        if ($(row).data('parent-id')) {
            $('#edit-category-parent-category-tree').jstree('deselect_all');
            $('#edit-category-parent-category-tree').jstree('select_node', $(row).data('parent-id'));
        }
    }
    getCategoryById(categoryId) {
        for (var i in g_categories_with_books) {
            if (g_categories_with_books[i].id == categoryId) {
                return g_categories_with_books[i];
            }
        }
        return null;
    }
    onCategoryDelClick(row) {
        var categoryId = row.getAttribute('rel');
        if (confirm('Are you sure you want to delete this category?')) {
            this.deleteCategory(categoryId);
        }
    }
    onAddCategoryClick() {
        //this.clearCategoryAddPopUp();
        //this.elCategoryAddPopup.dialog('open');
    }
    clearCategoryEditPopUp() {
        this.elEditName.val('');
        this.elEditCategoryDocumentList.html('');
    }
    clearCategoryAddPopUp() {
    }
    deleteCategory(category_id) {
        var form = $('<form action="#" method="post"><input type="hidden" name="category_id" value="' + category_id + '"/></form>');
        $('body').append(form);
        $(form).ajaxSubmit({
            url: URL_ADMIN + '/categories/delete/',
            type: 'post',
            dataType: 'json',
            data: {
                category_id: category_id
            },
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return;
    }
}
